// Loads a user's investor membership context for the edit modal (fetches on mount).
import { useEffect, useState } from 'react';
import { captureException } from '@startus/lib';
import { investorsService } from '../services/investors.service';
import type { UserInvestorMembership } from '../types/investor';

interface UseUserInvestorMembershipResult {
  context: UserInvestorMembership | null;
  loading: boolean;
  error: unknown;
}

export function useUserInvestorMembership(userId: string): UseUserInvestorMembershipResult {
  const [context, setContext] = useState<UserInvestorMembership | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    // Guards against setting state after the modal closes mid-request.
    let cancelled = false;

    investorsService
      .getUserMembership(userId)
      .then((data) => {
        if (!cancelled) setContext(data);
      })
      .catch((err: unknown) => {
        captureException(err, { userId });
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { context, loading, error };
}
